import React, { Component } from 'react';
import propTypes from 'prop-types';
import x from 'open-iconic/svg/x.svg';
import { Input } from 'reactstrap';

import AMPModal from 'app/AMPModal/container';
import sharedStyles from 'app/shared.css';
import { makeId } from 'utils/selectors';
import { IconButton } from 'ui/Components';

import HelpIcon from './HelpIcon';

/**
 * render a button that opens the amp connector modal
 */
export default class AMPConnector extends Component {
  static propTypes = {
    fieldContract: propTypes.shape({
      helpText: propTypes.string,
      name: propTypes.string,
      required: propTypes.bool
    }).isRequired,
    isReadonly: propTypes.bool,
    notifyFailure: propTypes.func.isRequired,
    onChange: propTypes.func.isRequired,
    selectedValue: propTypes.string,
    updateLocation: propTypes.string.isRequired,
    validationMessage: propTypes.string
  };

  static defaultProps = {
    isReadonly: false,
    selectedValue: '',
    validationMessage: undefined
  };

  constructor(props) {
    super(props);

    this.state = {};

    this.handleInputBlur = this.handleInputBlur.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleStateClear = this.handleStateClear.bind(this);
  }

  static getDerivedStateFromProps(props, state) {
    if (props.selectedValue !== state.selectedValue) {
      // try to parse url in selectedValue prop
      let url;
      try {
        url = new URL(props.selectedValue);
      } catch (err) {
        url = '';
      }
      return {
        url,
        selectedValue: props.selectedValue
      };
    }
    return null;
  }

  /**
   * call onChange prop with href of url state
   */
  handleInputBlur() {
    this.props.onChange(this.state.url.href);
  }

  /**
   * update w and h search params of url state
   * @param {object} event - event object
   */
  handleInputChange(event) {
    const val = event.target.value.trim();
    const { name } = event.target;
    const isDigits = /^\d*$/.test(val);

    if (isDigits) {
      this.setState(ps => {
        const url = new URL(ps.url);
        url.searchParams.set(name, val);
        return { url };
      });
    }
  }

  /**
   * clear the state and change the props
   */
  handleStateClear() {
    this.setState({ url: '' });
    this.props.onChange('');
  }

  render() {
    const {
      fieldContract: { helpText, name, required },
      isReadonly,
      onChange,
      notifyFailure,
      updateLocation,
      validationMessage
    } = this.props;

    const { url } = this.state;

    const isValid = url !== '';
    const isDisabled = isReadonly || !isValid;

    const displayUrl = isValid ? `${url.origin}${url.pathname}` : '';
    const widthVal = isValid ? url.searchParams.get('w') : '';
    const heightVal = isValid ? url.searchParams.get('h') : '';

    return (
      <div className="d-flex flex-column my-3">
        <span className="d-flex align-items-center font-weight-bold mb-2">
          {`${name}${required ? '*' : ''}`}
          {helpText && <HelpIcon id={makeId({ updateLocation })} message={helpText} />}
          <AMPModal
            className="ml-3"
            isReadonly={isReadonly}
            notifyFailure={notifyFailure}
            onChange={onChange}
            data-test-id={makeId({ updateLocation })}
          />
        </span>
        <span className={sharedStyles.fieldValidationMessage}>{validationMessage}</span>
        <div className="d-flex justify-content-between">
          <span className="font-weight-bold mb-2">Image URL</span>
          {isValid && (
            <IconButton
              alt="remove image"
              icon={x}
              rem={1.0}
              noMargin
              isReadonly={isReadonly}
              onClick={this.handleStateClear}
              className="mr-4"
              data-test-id={makeId({ name: 'remove-image' })}
            />
          )}
        </div>
        <span className="mb-2 pb-2">{displayUrl}</span>
        <div className="d-flex justify-content-between">
          <div className="d-flex flex-column mr-2">
            <span className="font-weight-bold">Width</span>
            <Input
              type="text"
              name="w"
              disabled={isDisabled}
              value={widthVal}
              onBlur={this.handleInputBlur}
              onChange={this.handleInputChange}
              data-test-id={makeId({ updateLocation, name: 'w' })}
            />
          </div>
          <div className="d-flex flex-column ml-2">
            <span className="font-weight-bold">Height</span>
            <Input
              type="text"
              name="h"
              disabled={isDisabled}
              value={heightVal}
              onBlur={this.handleInputBlur}
              onChange={this.handleInputChange}
              data-test-id={makeId({ updateLocation, name: 'h' })}
            />
          </div>
        </div>
      </div>
    );
  }
}
